import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Contact from './components/Contact';
import About from './components/About';
import Trial from './components/Trial';
import Footer from './components/Footer';
import PatientLayout from './components/app/PatientLayout';
import Dashboard from './components/app/Dashboard';
import SymptomLogger from './components/app/SymptomLogger';
import QuizAssessment from './components/app/QuizAssessment';
import SmartwatchData from './components/app/SmartwatchData';
import { usePageTracking } from './hooks/useFirebase';
import './App.css';

function LandingPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { sessionId } = usePageTracking('landing-page');

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Header isScrolled={isScrolled} />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/trial" element={<Trial />} />
        <Route path="/app" element={<PatientLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="symptoms" element={<SymptomLogger />} />
          <Route path="quiz" element={<QuizAssessment />} />
          <Route path="smartwatch" element={<SmartwatchData />} />
          <Route index element={<Dashboard />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
